module.exports = __webpack_public_path__ + "img/la.320babd6.png";